import { Injectable } from '@angular/core';
// tslint:disable-next-line:import-blacklist
import { Constants } from '@constants/constants';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';

export function utag7() {
  return sessionStorage.getItem(Constants.UserData.sid);
}
window['utag6'] = utag6;

export function utag6() {
  const customer = JSON.parse(sessionStorage.getItem(Constants.UserData.CUSTOMER));
  return {
    'p': [customer.type + '|' + customer.code]
  };
}
window['utag7'] = utag7;

export function utag8() {
  return JSON.parse(sessionStorage.getItem(Constants.UserData.CUSTOMER)).uid;
}
window['utag8'] = utag8;

@Injectable()
export class DsconfigService {
  static _cache;
  private initialized = false;
  private superPromise;
  private developEnviroment = false;

  constructor(
    private _http: HttpClient,
    public translate: TranslateService
    ) {
    this.initEnviroment();
  }

  initEnviroment() {
    if (window.location.hostname === 'localhost') {
      this.developEnviroment = true;
    }
  }

  /**
    * Inicia las llamadas del dsConfig, consumiendo el archivo remoto o local
    */
  init() {
    if (!this.initialized) {
      this.initialized = true;
      let urlConst = Constants.dsConfigRoute.ext;
      if (window.location.hostname === 'localhost') {
        urlConst = Constants.dsConfigRoute.dev;
        this.developEnviroment = true;
      }

      this.superPromise = new Promise<void>((resolve, reject) => {
        this._http.get(urlConst)
          .toPromise()
          .then((data) => {
            DsconfigService._cache = data;
            if (data['trusteer'] && data['trusteer'].enabled) {
              try {
                this.initTrusteer();
              } catch (err) {
              }
            }
            resolve();
          })
          .catch((err) => {
            urlConst = Constants.dsConfigRoute.int;
            const mainPromise = Promise;
            this._http.get(urlConst)
              .toPromise()
              .then((data) => {
                DsconfigService._cache = data;
                if (data['trusteer'] && data['trusteer'].enabled) {
                  this.initTrusteer();
                }
                resolve();
              })
              .catch(() => {
                reject();
              });
          });
      });
      return this.superPromise;
    } else {
      return this.superPromise;
    }
  }

  get() {
    return DsconfigService._cache;
  }

  getUrlBase(): string {
    if (this.developEnviroment) {
      return Constants.urlBase.localDev;
    } else {
      return document.location.origin;
    }
  }
  getGender() {
    const gender = Constants.gender;
    gender.forEach(element => {
      element.nombre = this.translate.instant(element.nombre);
    });
    return gender;
  }

  getVia() {
    const vias = Constants.via;
    vias.forEach(element => {
      element.nombre = this.translate.instant(element.nombre);
    });
    return vias;
  }

  getProvince() {
    return Constants.province;
  }

  getEmployeeType() {
    const employeeType = Constants.employeeType;
    employeeType.forEach(element => {
      element.nombre = this.translate.instant(element.nombre);
    });
    return employeeType;
  }

  getSecondary() {
    const xhrInt = new XMLHttpRequest();
    xhrInt.open('GEt', Constants.dsConfigRoute.int, false);
    xhrInt.send(null);
    if (xhrInt.status === 200) {
      DsconfigService._cache = JSON.parse(xhrInt.response);
    } else {
      // TODO: Fallan todas las llamadas al DSCONFIG
    }
  }


  /**
   * Recupera un valor en base a una ruta JSON
   * @param names ruta que se va  consumir dentro del json del dsconfig
   * @example getRoute('path1.pathchild.key') retornando lo que este dentro de {path1:{pathchild:{key:'valuetoReturn'}}}
   */
  public getRoute(names): any {
    if (!DsconfigService._cache) {
      this.get();
    }
    let obj = Object.assign({}, DsconfigService._cache);
    try {
      const routes = names.split('.');
      for (const rout of routes) {
        obj = obj[rout];
      }
      return obj;
    } catch (err) {
      return undefined;
    }
  }

  /*
  FUNCIONES PARA TRUSTEER
  */

  private initTrusteer() {
    this.setTrusteer();
    setTimeout(() => {
      try {
        window['utag9']('main_account');
      } catch (err) {
      }
    }, DsconfigService._cache.trusteer.timeout);
  }

  private setTrusteer() {
    try {
      const domainID = DsconfigService._cache.trusteer.url + '/' + DsconfigService._cache.trusteer.snippetID + '/ai7v.js';
      const f = document;
      const e = window;
      const i = e.location.protocol;
      const j = e.navigator.userAgent;
      let b;
      b = [
        ['src', [i === 'https:' ? 'https:/' : 'http:/', domainID].join('/')],
        ['type', 'text/javascript'],
        ['async', true]
      ];
      const g = 'XMLHttpRequest';
      let a = null;
      const k = !(/msie|trident|edge/i.test(j)) && e[g] && (a = new e[g]()).withCredentials !== undefined;
      const c = f.createElement('script');
      const h = f.getElementsByTagName('head')[0];

      if (k) {
        a.open('GET', b[0][1], b[2][1]);
        a.withCredentials = true;
        a.onreadystatechange = (d) => {
          if (a.readyState === 4 && a.status === 200) {
            c.type = 'script/meta';
            c.src = b[0][1];
            h.appendChild(c);
            new Function(a.responseText)();
          }
        };
        a.send();
      } else {
        setTimeout(() => {
          for (let d = 0, l = b.length; d < l; d++) {
            c.setAttribute(b[d][0], b[d][1]);
          }
          h.appendChild(c);
        }, 0);
      }
    } catch (err) {
    }
  }

}
